import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/store/redux';

export interface AccessoryPcpPaginationState {
  pageNum: number;
}

const initialState: AccessoryPcpPaginationState = {
  pageNum: 1,
};

const SLICE_NAME = 'accessoryPcpPagination';

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    saveAccessoryPcpPagination(state, action: PayloadAction<number>) {
      state.pageNum = action.payload;
    },

    reset() {
      return initialState;
    },
  },
});

export const { saveAccessoryPcpPagination, reset } = slice.actions;

export const getAccessoryPcpPagination = (state: RootState): number =>
  state.pages.accessoryPcpPagination.pageNum;

export default slice.reducer;
